import podcastSeoGuide2026 from "./posts/podcast-seo-guide-2026";
import howToRankPodcastOnGoogle2026 from "./posts/how-to-rank-your-podcast-on-google-2026";
import podcastTranscriptSeo from "./posts/podcast-transcript-seo";
import podcastContentRepurposing from "./posts/podcast-content-repurposing";
import podcastWorkflowAutomation from "./posts/podcast-workflow-automation";
import youtubeSeoForPodcasters from "./posts/youtube-seo-for-podcasters";
import podcastContentMarketing from "./posts/podcast-content-marketing";
import podcastEmailAutomation from "./posts/podcast-email-automation";
import podcastToSocialMedia from "./posts/podcast-to-social-media";
import bestPodcastRepurposingTools2026 from "./posts/best-podcast-repurposing-tools-2026";
import episodekitVsCastmagic from "./posts/episodekit-vs-castmagic";
import podcastToBlog from "./posts/podcast-to-blog";

// Central catalogue of blog posts. Each post is a self-contained JSX
// module that exports its frontmatter + a React body component. This
// keeps the system HTML-first (no markdown runtime), lightweight, and
// trivial to extend — adding a new post = creating one file + appending
// to this array.

export const POSTS = [
  podcastToBlog,
  episodekitVsCastmagic,
  bestPodcastRepurposingTools2026,
  podcastToSocialMedia,
  podcastEmailAutomation,
  podcastContentMarketing,
  youtubeSeoForPodcasters,
  podcastWorkflowAutomation,
  podcastContentRepurposing,
  podcastTranscriptSeo,
  howToRankPodcastOnGoogle2026,
  podcastSeoGuide2026,
];

export const getPostBySlug = (slug) =>
  POSTS.find((p) => p.slug === slug) || null;

// Posts sorted newest first for the index page + homepage preview.
export const sortedPosts = () =>
  [...POSTS].sort(
    (a, b) => new Date(b.publishedAt) - new Date(a.publishedAt),
  );
